<template>
	<div class="curriculumPage_main" id="read_page">
		<div class="curriculumPage_main_page">
			<div class="curriculumPage_left" :class="{curriculumPage_scroll:box_scorll}">
				<div class="curriculum_box" id="curriculumPage_left_box">
					<div class="curriculum_box_main">
						<p class="curriculumPage_left_title">{{$t('read.course')}}</p>
						<!-- 不能浏览样式：lessonNotLook  当前查看样式： lessonActive -->
						<div class="curriculumPage_left_ul">
							<ul>
								<li v-for="(item,index) in chapterList" :key="index" @click="change_first(item.id)">
									<p class="curriculum_week" :class="{lessonActive:topId == item.id}" :title="item.chapterName">{{item.chapterName}}</p>
									<label v-if="topId == item.id" v-for="(item2,index2) in item.secCourseOutlineList" :key="index2">
										<p class="curriculum_lesson" :class="{lessonActive:secondId == item2.id}" @click="change_second(item2.id)"
										 :title="item2.chapterName">{{item2.chapterName}}</p>
										<dl v-if="secondId == item2.id" v-for="(item3,index3) in item2.thirdOutlineList" :key="index3">
											<dd>
												<p class="curriculum_lesson_item" @click="((item3.materialType != '--' && item3.free == 1) || outlineInfo.isBuy == 1)&&  curriculum_lesson(item2,item3)">
													<span v-if="item3.materialType==1" :class="getclass(outlineInfo.isBuy,item3,thirdId)" :title="item3.chapterName"><span
														 v-if="getFreeFlag(outlineInfo.isBuy,item3)" class="tryAndSee">{{$t('read.trySee')}}</span>{{item3.chapterName}}</span>
													<span v-else-if="item3.materialType==2" :class="getclass(outlineInfo.isBuy,item3,thirdId)" :title="item3.chapterName"><span
														 v-if="getFreeFlag(outlineInfo.isBuy,item3)" class="tryAndSee">{{$t('read.trySee')}}</span>{{item3.chapterName}}</span>
													<span v-else :class="getclass(outlineInfo.isBuy,item3,thirdId)" :title="item3.chapterName"><span v-if="getFreeFlag(outlineInfo.isBuy,item3)"
														 class="tryAndSee">{{$t('read.trySee')}}</span>{{item3.chapterName}}</span>
												</p>
											</dd>
										</dl>
									</label>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="curriculumPage_middle" :class="{curriculumPage_scroll:box_scorll}">
				<div class="curriculum_box" id="curriculumPage_middle_box">
					<div class="curriculum_box_main">
						<textarea v-if="userId != 'tourist'" :placeholder="$t('read.tips')" v-model="newNote"></textarea>
						<p v-else class="noLogin">{{$t('read.login')}}</p>
						<div class="lesson_page" v-if="userId != 'tourist'">
							<p>
								<span>{{phaseNum}}/{{phaseCount}}</span>
							</p>
						</div>
						<p class="save_btn">
							<button v-if="userId != 'tourist'" @click="saveNote">{{$t('read.save')}}</button>
						</p>
					</div>
				</div>
			</div>
			<div class="curriculumPage_right" id="curriculumPage_right">
				<div class="curriculum_box" id="curriculum_box_right" ref="curriculum_box_right">
					<div class="curriculum_box_main">
						<div class="curriculum_img" ref="curriculum_img">
							<!--<img src="https://static.wixstatic.com/media/a36401_59cd11a52d634765bc56a4fe20ba405c~mv2_d_1214_1364_s_2.png/v1/fill/w_521,h_584,al_c,q_80,usm_0.66_1.00_0.01/%E5%B1%8F%E5%B9%95%E5%BF%AB%E7%85%A7%202019-03-26%20%E4%B8%8B%E5%8D%8810_46_19.webp">-->
							<pdf v-if="active" ref="pdf" :pdfurl="materialInfo.materialPath" v-on:page-num="pageNumChange" style="border-radius:10px 10px 0 0"></pdf>
						</div>
						<div class="pdf_page">
							<div class="page_pdf">
								<div class="lesson_page lesson_page_read">
									<p>
										<span :class="{lesson_page_disabled:phaseNum == 1}" @click="phaseNum > 1 && prevPage()" style="cursor:pointer"><i
											 class="el-icon el-icon-arrow-left"></i></span>
										<span>{{phaseNum}}/{{phaseCount}}</span>
										<span :class="{lesson_page_disabled:phaseNum == phaseCount}" @click="phaseNum < phaseCount && nextPage()"
										 style="cursor:pointer"><i class="el-icon el-icon-arrow-right"></i></span>
										<span>&nbsp;&nbsp;<input type="text" oninput="value=value.replace(/[^\d]/g,'')" v-model="jumpPhaseNum" @blur="jumpPhaseNum !=null && jumpPage(parseInt(jumpPhaseNum))"
											 @keyup.enter="jumpPhaseNum !=null && current_change(parseInt(jumpPhaseNum))">{{$t('read.page')}}</span>
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div style="clear: both;"></div>
		</div>
	</div>
</template>

<script>
import CPdf from "./pdfjs";
export default {
  name: "read",
  props: ["outlineInfo", "userId"],
  data() {
    return {
      icon_arrow: require("../../assets/read/icon_arrow.png"),
      topId: "", //当前一级章节章节点
      secondId: "", //当前二级章节章节点
      thirdId: "", //当前三级章节章节点
      week_show: 0, //展示周数据
      lesson_show: 0, //展示lesson数据
      lesson_active: 702, //当前展示课程章节
      chapterList: [], //章节列表
      note: null, //笔记内容
      newNote: null, //用户修改后笔记内容
      materialInfo: {}, //学习资料信息
      phaseNum: 1, //笔记当前页
      jumpPhaseNum: null, //跳页
      prePhaseNum: 1, //笔记上一页，作用于取消翻页时重置页码
      pdfNum: 1, //pdf页码
      totalPhase: 10, //总阶段数
      timing: null, //计时器
      phaseCount: 10,
      active: false, //控制pdf子组件加载
      prev_disabled: false,
      next_disabled: true,
      box_scorll: false //目录、笔记是否以浮窗形式显示
    };
  },
  watch: {
    "outlineInfo.thirdId"(newVal, oldVal) {
      document.getElementById("app").scrollTo(0, 0);
      if (newVal) {
        if (this.outlineInfo.type == "2") {
          this.init();
        }
      }
    }
  },
  components: {
    pdf: CPdf
  },
  created() {
    this.init();
  },
  methods: {
    getclass: function(isbuy, item3, thirdId) {
      //当前选中
      if (thirdId == item3.id) {
        return "lessonActive";
      }
      //已购买，允许试看，不为作业类型允许看
      if (isbuy == 1 || (item3.free == 1 && item3.materialType != "--")) {
        return "";
      } else {
        return "lessonNotLook";
      }
    },
    getFreeFlag: function(isbuy, item3) {
      if (isbuy == 0 && item3.free == 1 && item3.materialType != "--") {
        return true;
      } else {
        return false;
      }
    },
    init: function() {
      //计算页面停留时间
      let time = 0;
      this.timing = setInterval(() => {
        time += 1;
        if (time > 10) {
          this.finishLearning();
          clearInterval(this.timing);
        }
      }, 1000);
      //离开页面清除计时方法
      this.$once("hook:beforeDestroy", () => {
        clearInterval(this.timing);
      });
      //设置当前章节点信息
      this.topId = this.outlineInfo.topId;
      this.secondId = this.outlineInfo.secondId;
      this.thirdId = this.outlineInfo.thirdId;
      //获取全部章节点信息
      this.$api
        .post("/courseStudy/getWholeOutlineList", {
          courseId: this.outlineInfo.courseId
        })
        .then(response => {
          this.chapterList = response.data;
        });

      //获取学习资料
      this.$api
        .post("/courseStudy/getCourseMaterial", {
          courseOutlineId: this.thirdId
        })
        .then(response => {
          this.materialInfo = response.data[0];
          this.active = true;
        })
        .then(() => {
          //登录状态下获取笔记
          if (this.userId) {
            //获取笔记
            this.$api
              .post("/courseStudy/getMaterialNote", {
                materialId: this.materialInfo.id,
                phaseNum: this.phaseNum
              })
              .then(response => {
                if (response.data[0]) {
                  this.note = response.data[0].noteContent;
                  this.newNote = response.data[0].noteContent;
                }
              });
          }
        });
    },
    //点击一级章节点
    change_first: function(topId) {
      this.topId = topId;
    },
    //点击二级章节点
    change_second: function(secondId) {
      this.secondId = secondId;
    },
    curriculum_lesson: function(item2, item3) {
      let outlineInfo = {
        topId: item2.parentId,
        secondId: item3.parentId,
        thirdId: item3.id,
        type: item3.materialType,
        secondChapterName: item2.chapterName
      };
      //清除当前计时器
      clearInterval(this.timing);
      this.$emit("change-outline", outlineInfo);
    },
    pageNumChange(pageNum, pageCount) {
      this.pdfNum = pageNum;
      this.phaseCount = pageCount;

      // 					//适配pdf容器的高度
      // 				vm.$refs.curriculum_img.style.minHeight = document.getElementById("cpdf").clientWidth*1.44 +"px"
    },
    nextPage: function() {
      this.$refs.pdf.next();
      if (this.userId != "tourist") {
        this.current_change(this.phaseNum + 1);
      }
    },
    prevPage: function() {
      this.$refs.pdf.prev();
      if (this.userId != "tourist") {
        this.current_change(this.phaseNum - 1);
      }
    },
    jumpPage: function(pageNum) {
      this.$refs.pdf.jump(pageNum);
      if (this.userId != "tourist") {
        this.current_change(pageNum);
      }
    },
    saveNote: function() {
      if (this.outlineInfo.isBuy == "0") {
        this.$el_alert_type("请购买课程", "warning");
        return;
      }
      if (this.newNote) {
        let array = this.newNote.split("\n");
        let rows = 0;
        array.forEach(obj => {
          let chinese = obj.match(/[\u4e00-\u9fa5。，？”“《》：！——-、]/g); //匹配中文，match返回包含中文的数组
          let chineselength = chinese ? chinese.length : 0;
          let currentRows = Math.ceil((obj.length + chineselength) / 25);
          rows += currentRows;
        });
        //笔记最大允许行数为60行
        if (rows > 60) {
          this.$el_alert_type(window.vm.$i18n.t('js.wordMore'), "warning");
          return;
        }

        this.$api
          .post("/courseStudy/insertMaterialNote", {
            materialId: this.materialInfo.id,
            phaseNum: this.phaseNum,
            noteContent: this.newNote
          })
          .then(() => {
            this.note = this.newNote;
            this.$el_alert_type(window.vm.$i18n.t('js.saveSuccess'), "success");
          });
      }
    },
    downloadFile: function() {
      if (this.outlineInfo.isBuy == "0") {
        this.$el_alert_type("请购买后再下载文档", "warning");
        return;
      }
      this.$api
        .post("/courseStudy/saveMaterials", {
          materialId: this.materialInfo.id,
        })
        .then(response => {
          window.open(response.data, "_blank");
        });
    },
    downloadOriginalFile: function() {
      if (this.outlineInfo.isBuy == "0") {
        this.$el_alert_type("请购买后再下载文档", "warning");
        return;
      }
      window.open(this.materialInfo.materialPath, "_blank");
    },
    //设置当前课程学习完成
    finishLearning: function() {
      if (this.userId != "tourist") {
        this.$api.post("/courseStudy/changeUserLearnState", {
          courseOutlineId: this.thirdId,
          learningState: 1
        });
      }
    },
    current_change: function(val) {
      this.jumpPhaseNum = null;
      if (val > this.phaseCount) {
        this.$el_alert_type(window.vm.$i18n.t('js.mostPage'), "warning");
        return;
      }
      if (this.newNote != this.note) {
        this.$confirm("您当前未保存笔记", "提示", {
          distinguishCancelAndClose: true,
          confirmButtonText: "确定：保存笔记",
          cancelButtonText: "取消：不保存笔记",
          type: "warning"
        })
          .then(() => {
            this.saveNote();
            this.notePageChange(val);
          })
          .catch(action => {
            if (action == "cancel") {
              this.notePageChange(val);
            } else {
              //取消翻页重置页码
              //this.phaseNum = this.prePhaseNum
            }
          });
      } else {
        this.notePageChange(val);
      }
    },
    //笔记翻页
    notePageChange: function(val) {
      this.phaseNum = val;
      //成功翻页同步当前页和上一页
      //this.prePhaseNum = val;
      //获取笔记
      this.$api
        .post("/courseStudy/getMaterialNote", {
          materialId: this.materialInfo.id,
          phaseNum: val
        })
        .then(response => {
          if (response.data[0]) {
            this.note = response.data[0].noteContent;
            this.newNote = response.data[0].noteContent;
          } else {
            this.note = null;
            this.newNote = null;
          }
        });
    },
    handleScroll() {
      let scrollTop = document.getElementById("app").scrollTop;
      let h = document.getElementById("curriculumPage_right").offsetHeight;
      let top = document.getElementById("read_page").offsetTop;

      //pdf区域滚动后，区域内显示的距离
      let scroll_h = top + h - scrollTop - 40;

      if (scrollTop > 150) {
        this.box_scorll = true;
        document.getElementById("curriculumPage_left_box").style.height =
          scroll_h - 32 + "px";
        document.getElementById("curriculumPage_middle_box").style.height =
          scroll_h - 32 + "px";
      } else {
        this.box_scorll = false;
      }
    }
  },
  mounted() {
    //给window添加一个滚动滚动监听事件
    document
      .getElementById("app")
      .addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    //离开该页面需要移除这个监听的事件
    document
      .getElementById("app")
      .removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped="scoped">
input,
textarea:focus {
  outline: none;
}

.icon_arrow_img {
  margin-left: 20px;
}

.curriculumPage_main {
  margin-top: 20px;
  position: relative;
}

.curriculumPage_main_page {
  min-width: 1200px;
  position: relative;
  margin: 0 auto;
  display: -webkit-box;
}

.curriculumPage_left,
.curriculumPage_middle,
.curriculumPage_right {
  min-height: 627px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
  margin-left: 10px;
}

.curriculumPage_left {
  margin-left: 0;
  width: 244px;
  display: grid;
}

.curriculumPage_middle {
  width: 414px;
}

.curriculumPage_right {
  min-width: 521px;
  width: calc(100% - 678px);
  /* min-height: 796px; */
  /* min-height: 816px; */
  /* height: 100%; */
  /* position: relative; */
  border-radius: 10px;
  /* display: inline-table; */
  padding-bottom: 50px;
  position: relative;
}

.curriculum_box {
  width: 100%;
  margin-top: 20px;
  /* overflow: auto; */
  /* padding-bottom: 40px; */
}

.curriculumPage_right .curriculum_box {
  margin-top: 0;
  overflow: hidden;
  border-radius: 10px 10px 0 0;
}
.curriculumPage_right .curriculum_box canvas {
  border-radius: 10px 10px 0 0 !important;
}

.curriculum_box_main {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  /*max-height: 600px;*/
}

.curriculumPage_left .curriculum_box {
  width: 244px;
  height: 100%;
}

.curriculumPage_left .curriculum_box .curriculum_box_main {
  height: 100%;
}

/* .curriculumPage_right .curriculum_box .curriculum_box_main {
		position: absolute;
	} */

.curriculumPage_left .curriculumPage_left_title {
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #e8e6e6;
  text-indent: 10px;
  text-align: center;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.curriculumPage_left .curriculumPage_left_ul {
  width: 242px;
  height: calc(100% - 80px);
  overflow-y: auto;
  position: absolute;
}

.curriculumPage_left .curriculumPage_left_ul ul {
  /* height: calc(100% - 50px); */
  /* position: relative; */
  /* overflow: hidden;
		zoom: 1; */
  padding: 10px;
}

.curriculumPage_left .curriculumPage_left_ul ul li {
  width: 100%;
  list-style: none;
}

.curriculumPage_left .curriculumPage_left_ul ul li .curriculum_week {
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  color: #c2c2c2;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* font-family: lato, sans-serif;
		font-weight: 300;
		font-style: normal; */
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
}
.curriculumPage_left .curriculumPage_left_ul ul li .curriculum_week:hover {
  color: #fff;
  transition: 0.5s ease;
}

.curriculumPage_left .curriculumPage_left_ul ul li .curriculum_lesson {
  width: 210px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #c2c2c2;
  text-indent: 20px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: lato, sans-serif;
  font-weight: 300;
  font-style: normal;
}

.curriculumPage_left .curriculumPage_left_ul ul li .curriculum_lesson:hover,
.curriculum_lesson_item:hover,
.lessonActive {
  color: #fff !important;
}

.lessonNotLook {
  color: #d7d7d7 !important;
}

.curriculumPage_left ul li dl {
  width: 80%;
  margin-left: 20%;
}

.curriculumPage_left ul li dl dd {
  list-style: none;
}

.curriculumPage_left ul li dl dd .curriculum_lesson_item {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #c2c2c2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  font-family: lato, sans-serif;
  font-weight: 300;
  font-style: normal;
}

.curriculumPage_middle .curriculum_box,
.curriculumPage_middle .curriculum_right {
  overflow: hidden;
}

.curriculumPage_middle .curriculum_box {
  width: 414px;
  height: calc(100% - 20px);
  position: absolute;
}

.curriculumPage_middle textarea {
  width: 375px;
  /* height: 636px; */
  height: calc(100% - 120px);
  margin-left: 4%;
  border: 0;
  padding: 10px;
  background-color: unset;
  border: 0;
  font-size: 14px;
  color: #fff;
  resize: none;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.curriculumPage_middle textarea:focus {
  border: 0 !important;
}

.curriculumPage_middle .save_btn {
  width: 414px;
  height: 60px;
  bottom: 0;
  position: absolute;
  border-top: 1px#414141 solid;
}

.curriculumPage_middle .save_btn button {
  width: 60px;
  line-height: 12px;
  margin-top: 18px;
  margin-left: 177px;
  font-size: 12px;
  color: #fff;
  background-color: unset;
  border-radius: 20px;
  border: 1px #fff solid;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  padding: 5px 0 6px 0;
  transition: 0.5s ease;
}

.curriculumPage_middle .save_btn button:hover {
  background-color: #ffff;
  color: #000;
  transition: 0.5s ease;
}

.curriculumPage_right .curriculum_img {
  min-width: 521px;
  width: 100%;
  /* min-height: 737px;
		margin: 2px;*/
}

.curriculumPage_right .curriculum_img #cpdf {
  width: 100% !important;
}

.curriculumPage_right .pdf_page {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
}

.curriculumPage_right .img_btn {
  position: absolute;
  margin-top: 16px;
}

.curriculumPage_right .img_btn_right {
  float: right;
  position: relative;
  margin-top: -33px;
  -moz-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  transform: scaleX(-1);
  filter: FlipH();
}

.curriculumPage_right .img_btn img {
  width: 23px;
  height: 17px;
}

/* .curriculumPage_right .img_btn svg {
		width: 20px;
		height: 20px;
		margin: 10px 20px;
		fill-opacity: 1;
		stroke-width: 0;
		stroke: rgb(94, 151, 255);
		stroke-opacity: 1;
		fill: rgb(250, 250, 250);
	} */

.page_pdf {
  width: 66%;
  height: 50px;
  line-height: 50px;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  color: #fff;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.noLogin {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #fff;
  padding-left: 30px;
}

.tryAndSee {
  width: 44px;
  height: 18px;
  line-height: 18px;
  transform: scale(0.8);
  display: inline-block;
  background-color: #292a2b;
  border-radius: 10px;
  border: solid 1px #7e7e7e;
  opacity: 0.59;
  font-family: PingFang-SC-Regular;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #999999;
  text-align: center;
  margin-right: 6px;
  float: left;
}

.lesson_page {
  width: 414px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  position: absolute;
  bottom: 65px;
}

.lesson_page span {
  font-size: 14px;
  color: #fff;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.lesson_page span:nth-child(2) {
  margin: 0 10px;
}

.lesson_page span:nth-child(4) {
  margin-left: 10px;
}

.lesson_page span input {
  width: 40px;
  height: 20px;
  border-radius: 4px;
  outline: none;
  border: 0px;
  margin: 0 5px;
  text-align: center;
  font-size: 14px;
  color: #414141;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.lesson_page span input:focus {
  border: 0 !important;
}

.lesson_page_disabled i {
  color: #858585 !important;
}

.lesson_page_read {
  width: 66%;
  height: 50px;
  line-height: 50px;
  bottom: 0 !important;
  margin: 0 auto;
}

.curriculumPage_scroll {
  background-color: unset;
  box-shadow: unset;
}

.curriculumPage_scroll .curriculum_box {
  position: fixed;
  /* height: calc(100% - 112px); */
  margin-top: 52px;
  top: 0;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/components/curriculum/read.vue